import styled from 'styled-components'

import { Button } from 'pcln-design-system'

const ExpressButton = styled(Button)`
  color: white;
  width: 143px;
  height: 31px;
  font-size: 12px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px;
  padding: 4px;
  border-radius: 3px;
`

ExpressButton.displayName = 'ExpressButton'

export default ExpressButton
